import { Column, Grid } from "@carbon/react";
import { ArrowDownLeft, ArrowUpRight } from "@carbon/react/icons";

import {
  Card,
  CurrencyDisplay,
  QuickSummary,
  SummaryTable,
} from "../../components";
// import { quickSummaryColumData } from "../../test-data";

import arrowUpRightGreen from "../../assets/icons/arrow-up-right-green.svg";
import arrowDownLeftRed from "../../assets/icons/arrow-down-left-red.svg";

export const QuickSummaryColumData = ({ quickSummaryColumData }) => {
  // const formattedData = quickSummaryColumData.map((item, index) => ({
  //   ...item,
  //   // ...(index === 0 && {
  //   //   renderIcon: () => (
  //   //     <div>
  //   //       <div className="badge-with-icon icon-success font-ctm--regular">
  //   //         <ArrowUpRight className="badge-icon" />
  //   //         <span className="icon-text">
  //   //           {quickSummaryColumData[0].iconText}
  //   //         </span>
  //   //       </div>
  //   //     </div>
  //   //   ),
  //   // }),
  //   // ...(index === 1 && {
  //   //   renderIcon: () => (
  //   //     <div className="badge-with-icon icon-danger font-ctm--regular">
  //   //       <ArrowDownLeft className="badge-icon" />
  //   //       <span className="icon-text">{quickSummaryColumData[1].iconText}</span>
  //   //     </div>
  //   //   ),
  //   // }),
  // }));

  return (
    <Card>
      <Grid>
        <Column sm={0} md={8} lg={16}>
          <div className="flex-container">
            <div className="flex-box">
              <QuickSummary
                title={quickSummaryColumData[0].key}
                value={
                  <CurrencyDisplay
                    amount={quickSummaryColumData[0].value}
                    currencyOrSymbol={quickSummaryColumData[0].prefix}
                    amountClassName="font-ctm--bold"
                    symbolClassName="font-ctm--bold"
                  />
                }
                // icon={
                //   <div className="badge-with-icon icon-success font-ctm--regular">
                //     <img
                //       src={arrowUpRightGreen}
                //       alt="arrow up"
                //       className="align-icon--center"
                //     />
                //     <span className="icon-text">
                //       {quickSummaryColumData[0].iconText}
                //     </span>
                //   </div>
                // }
              />
            </div>

            <div className="flex-divider--vertical" />

            <div className="flex-box">
              <QuickSummary
                title={quickSummaryColumData[1].key}
                value={
                  <CurrencyDisplay
                    amount={quickSummaryColumData[1].value}
                    currencyOrSymbol={quickSummaryColumData[1].prefix}
                    amountClassName="font-ctm--bold"
                    symbolClassName="font-ctm--bold"
                  />
                }
                // icon={
                //   <div className="badge-with-icon icon-danger font-ctm--regular">
                //     <img
                //       src={arrowDownLeftRed}
                //       alt="arrow down"
                //       className="align-icon--center"
                //     />
                //     <span className="icon-text">
                //       {quickSummaryColumData[1].iconText}
                //     </span>
                //   </div>
                // }
              />
            </div>

            <div className="flex-divider--vertical" />

            <div className="flex-box">
              <QuickSummary
                title={quickSummaryColumData[2].key}
                value={quickSummaryColumData[2].value}
              />
            </div>

            <div className="flex-divider--vertical" />

            <div className="flex-box">
              <QuickSummary
                title={quickSummaryColumData[3].key}
                value={quickSummaryColumData[3].value}
              />
            </div>

            <div className="flex-divider--vertical" />

            <div className="flex-box">
              <QuickSummary
                title={quickSummaryColumData[4].key}
                value={quickSummaryColumData[4].value}
              />
            </div>
          </div>
        </Column>

        <Column sm={4} md={0} lg={0}>
          <SummaryTable
            Title="Quick Summary"
            data={quickSummaryColumData}
            renderRow={(val, i) => (
              <>
                <td>
                  {val.key}
                  {val.renderIcon && val.renderIcon()}
                </td>
                <td align="right">
                  {quickSummaryColumData[i].prefix ? (
                    <CurrencyDisplay
                      amount={quickSummaryColumData[i].value}
                      currencyOrSymbol={quickSummaryColumData[i].prefix}
                      amountClassName="font-ctm--semibold"
                    />
                  ) : (
                    <div>
                      <h4 className="font-ctm--bold">
                        {quickSummaryColumData[i].value}
                      </h4>
                    </div>
                  )}
                </td>
                <td> {">"}</td>
              </>
            )}
          />
        </Column>
      </Grid>
    </Card>
  );
};
